import BlogPost from './blog_post';
export default BlogPost;
